import {
  Box,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MultiCheckBoxes from "../../../../Components/MultiCheckBox/MultiCheckBoxes";
import { useLocation, useNavigate } from "react-router-dom";
import MuiButton from "../../../../Components/Button/Button";
import MuiInputField from "../../../../Components/InputField/InputField";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "../../../../Components/FileUpload/FileUpload";
import {
  genericFetchData,
  uploadDocuments,
} from "../../../../Services/Service";
import MultiSelectDropDown from "../../../../Components/DropDown/MultiSelectDropDown";
import TextEditor from "../../../../Components/TextEditor/TextEditor";
import Op from "../../Hospital/Finance/Domestic/Finance/Op/Op";
import DropDown from "../../../../Components/DropDown/DropDown";
import AddButton from "../../../../Components/AddButton/AddButton";
import { FinanceSection } from "./FinanceSection";
import { IPSection } from "./IPSection";
import { PersonalDetails } from "./PersonalDetails";
import {
  DOCTOR_CONTEXT,
  doctor_agreement,
  doctor_image,
  doctor_medical_council_document,
} from "../../../../Utils/AppConstance";
import { checkPermission } from "../../../../Utils/Permissions";
import { PersonalDetailsView } from "./PersonalDetailsView";
import { isEmpty } from "../../../../Utils/helper";
import { FinanceView } from "./FinanceView";
import OpView from "./OPView";
import { IpView } from "./IPView";
import { makeStyles } from "@mui/styles";
import Journy from "../../../../Components/Details.jsx/Journy";
import { Edit } from "@mui/icons-material";
import { DisApprove } from "../../../../Assets/Icons/DisApprove";
import DisApproveModal from "../../../../Components/ModalPopUp/DisApproveModal";
import ApproveModa from "../../../../Components/ModalPopUp/ApproveModa";
import { getUserRole } from "../../../../Storage/Datastore";
import Rejection from "../../../../Components/Details.jsx/Rejection";
import AgreementDoctor from "./Agreement/AgreementDoctor";

const useStyles = makeStyles({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: "white",
      backgroundColor: "#414851",
      borderRadius: "6px",
      minHeight: "35px",
      maxHeight: "35px",
      fontSize: "15px",
      textTransform: "capitalize",
      fontFamily: "poppins",
    },
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root": {
      textTransform: "capitalize",
      fontFamily: "poppins",
    },
  },
});

function FinanceTab(props) {
  const location = useLocation();
  const [isReadOnly, setIsReadOnly] = useState(true);
  const locationData = location?.state?.data && location?.state?.data;
  const [activeTab, setActiveTab] = useState(0);
  const [showApproval, setshowApproval] = useState(true);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const currentTab = "OPERATIONS";
  const department = locationData?.department?.trim();
  const presentTab = department?.toUpperCase() === currentTab?.toUpperCase();

  useEffect(() => {
    switch (department) {
      case "OPERATIONS":
        setActiveTab(0);
        break;
      case "FINANCE":
        setActiveTab(1);
        break;
      default:
        break;
    }
  }, [department]);
  return (
    <Grid>
      {activeTab === 1 && locationData?.rejectedReason && (
        <Rejection
          locationData={locationData}
          setIsFinanceEditable={props.setIsFinanceEditable}
          isActivetab={"FINANCE"}
          setDrIsReadOnly={setIsReadOnly}
          setshowApproval={setshowApproval}
        />
      )}
      <Box
        border={
          !checkPermission("KARE_DB_FINANCE_EDIT")
            ? "1px solid lightgrey"
            : "none"
        }
        borderRadius={2}
        marginTop={!checkPermission("KARE_DB_FINANCE_EDIT") ? 2 : 0}
        paddingX={5}
        paddingY={5}
      >
        {checkPermission("KARE_DB_FINANCE_EDIT") ? (
          // <FinanceSection
          //   details={props.details}
          //   setDetails={props.setDetails}
          //   isEditable={props.isFinanceEditable}
          //   id={props.id}
          //   setIsEditable={props.setIsFinanceEditable}></FinanceSection>
          <AgreementDoctor
            id={props.id}
            isReadOnly={isReadOnly}
            setIsReadOnly={setIsReadOnly}
            showApproval={showApproval}
            setshowApproval={setshowApproval}
          />
        ) : (
          <FinanceView
            details={props.details}
            setDetails={props.setDetails}
            isEditable={false}
            id={props.id}
            setIsEditable={props.setIsFinanceEditable}
          />
        )}

        {!checkPermission("KARE_DB_FINANCE_EDIT") && <Divider />}

        {/* {checkPermission("KARE_DB_FINANCE_EDIT") ? (
          <Op
            isEditable={props.isFinanceEditable}
            setFee={(value) =>
              props.setDetails((s) => ({
                ...s,
                doctorFinance: {
                  ...s.doctorFinance,
                  opMinConsultationFee: value,
                },
              }))
            }
            fee={props.details?.doctorFinance?.opMinConsultationFee}
            share={props.details?.doctorFinance?.opMykareShare}
            setShare={(value) => {
              props.setDetails((s) => ({
                ...s,
                doctorFinance: { ...s.doctorFinance, opMykareShare: value },
              }));
            }}
          />
        ) : (
          <OpView
            isEditable={false}
            setFee={(value) =>
              props.setDetails((s) => ({
                ...s,
                doctorFinance: {
                  ...s.doctorFinance,
                  opMinConsultationFee: value,
                },
              }))
            }
            fee={props.details?.doctorFinance?.opMinConsultationFee}
            share={props.details?.doctorFinance?.opMykareShare}
            setShare={(value) => {
              props.setDetails((s) => ({
                ...s,
                doctorFinance: { ...s.doctorFinance, opMykareShare: value },
              }));
            }}
          />
        )} */}

        {/* {checkPermission("KARE_DB_FINANCE_EDIT") ? (
          <IPSection
            treatments={props.treatments}
            details={props.details}
            setDetails={props.setDetails}
            isEditable={props.isFinanceEditable}></IPSection>
        ) : (
          <IpView
            treatments={props.treatments}
            details={props.details}
            setDetails={props.setDetails}
            isEditable={false}
          />
        )} */}

        {/* {checkPermission("KARE_DB_FINANCE_EDIT") && (
          <Grid container lg={12} marginY={"20px"}>
            {props.isFinanceEditable && (
              <Grid lg={1.1}>
                <AddButton
                  onClick={props.handleDuplicate}
                  labelName={"Add New"}
                  viewHeight={"45px"}
                  borderRadius={"7px"}
                />
              </Grid>
            )}
          </Grid>
        )} */}
        {/* {checkPermission("KARE_DB_FINANCE_EDIT") && (
          <Grid container lg={12} marginY={"20px"} justifyContent={"flex-end"}>
            {props.isFinanceEditable && (
              <Grid lg={0.9}>
                <MuiButton
                  onClick={() => {
                    props.financeDetailSave();
                  }}
                  padding="10px 30px"
                  viewHeight="45px"
                  bgColor="#17dfba"
                  borderRadius="5px"
                  title={"Save"}
                />
              </Grid>
            )}
          </Grid>
        )} */}
      </Box>
    </Grid>
  );
}

export default function AddNewDoctor() {
  const classes = useStyles();
  const navigate = useNavigate();
  const items = [
    { id: 1, name: "List in Mykare" },
    { id: 2, name: "List in KareTrip" },
    { id: 3, name: "List in Karemitra" },
  ];
  const location = useLocation();
  const id = location?.state && location?.state?.id;
  const taskId = location?.state?.taskId && location?.state?.taskId;
  const locationData = location?.state?.data && location?.state?.data;

  const isLive = location?.state && location?.state?.isLive;
  const state = location?.state?.data;

  const [checkedItemsId, setCheckedItemsId] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [doctorType, setDoctorType] = useState("HOSPITAL_RMP");
  const [duplicateName, setDuplicateName] = useState(false);
  const [departments, setDepartments] = useState({});
  const [hospitals, setHospitals] = useState({});
  const [rejectedReason, setRejectedReason] = useState("");
  const [isEditable, setIsEditable] = useState(true);
  const [error, setError] = useState(false);
  const userRole = getUserRole();
  const currentTab = "OPERATIONS";
  const department = locationData?.department?.trim();
  const presentTab = department?.toUpperCase() === currentTab?.toUpperCase();

  const isShow = (() => {
    if (checkedItemsId.includes(2)) {
      if (checkedItemsId.length > 1) {
        return false;
      }
      return true;
    }
  })();

  useEffect(() => {
    switch (department) {
      case "OPERATIONS":
        setActiveTab(0);
        break;
      case "FINANCE":
        setActiveTab(1);
        break;
      default:
        break;
    }
  }, [department]);

  const [details, setDetails] = useState({
    about: "",
    alternateContactNumber: "",
    approved: true,
    contactNumber: "",
    departmentId: 0,
    doctorFinance: null,
    professionalId: 0,
    doctorTreatmentShares: [
      {
        doctorShare: "",
        treatmentId: 0,
      },
    ],
    email: "",
    referralLink: null,
    centerId: 0,
    name: "",
    qualificationIds: [],
    registrationNumber: "",
    specialisationIds: [],
    startYear: "",
  });
  const [isPersonalEditable, setIsPersonalEditable] = useState(true);
  const [isFinanceEditable, setIsFinanceEditable] = useState(true);
  const [doc, setDoc] = useState({
    doctorDoc: [],
    agreementDoc: [],
    agreementDocument: [],
    document: [],
    image: [],
    doctorImage: [],
    documentIds: [],
  });
  const [qualification, setQualification] = useState({});
  const [specialization, setSpecialization] = useState({});
  const [isDoctorlFieldsValid, setIsDoctorlFieldsValid] = useState({
    isName: false,
    experience: false,
    qualification: false,
    department: false,
    center: false,
  });

  const getAllQualification = async () => {
    const response = await genericFetchData(`/qualification/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setQualification(responseData);
    } else {
      console.log("=======error", responseData);
    }
  };
  const getAllSpecialization = async () => {
    const response = await genericFetchData(`/specialization/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setSpecialization(responseData);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getAllDepartments = async () => {
    const response = await genericFetchData(`/departments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setDepartments(responseData.departments);
    } else {
      console.log("=======error", responseData);
    }
  };
  const getAllhospitals = async () => {
    const response = await genericFetchData(`/center/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setHospitals(responseData.centers);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getDocuments = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${DOCTOR_CONTEXT}&category=${doctor_medical_council_document}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDoc((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getImages = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${DOCTOR_CONTEXT}&category=${doctor_image}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDoc((s) => ({ ...s, image: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getAgreementDoc = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${DOCTOR_CONTEXT}&category=${doctor_agreement}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDoc((s) => ({ ...s, agreementDocument: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const saveDoctorDocuments = async (doc, contextId, category) => {
    const data = {
      documents: doc,
      context: DOCTOR_CONTEXT,
      category: category,
      contextId: contextId,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        alert("Document saved successfully");
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const handleDisapprove = async (status) => {
    let department = locationData?.department;

    if (status === "REJECTED" && !rejectedReason) {
      console.log("Rejected reason is required for REJECTED status.");
      return;
    }

    let selectedDepartment = department ? department : 'OPERATIONS'

    const postData = {
      departmentApproved: { [selectedDepartment]: status },
      dataType: "PROFESSIONAL",
      taskId: taskId,
      typeId: id,
      userRole: userRole,
      rejectedReason: rejectedReason,
    };
    try {
      const response = await genericFetchData(
        `/myspace/task/update`,
        "POST",
        postData
      );
      // const status = response.status;
      const responseData = await response.json();
      if (response.status === 200) {
        if (status === "REJECTED") navigate("/mySpace");
        else {
          navigate("/doctors");
        }
      }
      // if (status === 200) {
      //   setDomDoc((s) => ({ ...s, document: responseData }));
      // } else {
      //   console.log("=======error", responseData);
      // }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const handleDuplicate = () => {
    const newDuplicate = {
      doctorShare: "",
      treatmentId: 0,
    };
    setDetails((prevDuplicates) => ({
      ...prevDuplicates,
      doctorTreatmentShares: [
        ...prevDuplicates.doctorTreatmentShares,
        newDuplicate,
      ],
    }));
  };

  const getDoctorDetails = async (professionalId) => {
    const response = await genericFetchData(
      `/professional/${professionalId}`,
      "GET"
    );
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      const { treatmentShareResponses, financeResponse, ...updatedData } =
        responseData;
      setDetails({
        ...updatedData,
        doctorFinance: financeResponse,
        doctorTreatmentShares: treatmentShareResponses.length
          ? treatmentShareResponses
          : [
            {
              doctorShare: "",
              treatmentId: 0,
            },
          ],
      });
      if (responseData.isMykare) {
        responseData.platforms.push({ id: 0, name: "This is mykare Doctor?" });
      }
      const matchingData = responseData?.platforms?.map((item) => {
        setCheckedItems((prevCheckedItems) => ({
          ...prevCheckedItems,
          [item.id]: true,
        }));
      });

      setCheckedItems((prevCheckedItems) => ({
        ...prevCheckedItems,
        [0]: responseData.isMykare,
      }));
      const ids = responseData?.platforms?.map((item) => item.id);
      if (responseData.isMykare) {
        ids.push(0);
      }
      setCheckedItemsId(ids);
      setIsEditable(false);
      if (responseData.financeResponse) {
        setIsFinanceEditable(false);
      }
      setIsPersonalEditable(false);
    } else {
      console.log("=======error", responseData);
    }
  };

  const [treatments, setTreatments] = useState([]);

  const getAllTreatments = async () => {
    const response = await genericFetchData(`/treatments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setTreatments(responseData.treatments);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getDuplicateDoctor = async () => {
    const name = details.name;
    try {
      const response = await genericFetchData(
        `/professional/checkDuplicate?name=${name}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        console.log(responseData, "checking");
        const nameExist = responseData.some(
          (item) => item.name && item.name === name
        );
        if (nameExist) {
          setDuplicateName(true);
        } else {
          console.log("doesnt exist");
          setDuplicateName(false);
        }
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  useEffect(() => {
    getDuplicateDoctor();
  }, [details?.name]);

  const personalDetailSave = async () => {
    const postData = {
      about: details.about,
      alternateContactNumber: details.alternateContactNumber,
      contactNumber: details.contactNumber,
      departmentId: details.departmentId
        ? details.departmentId
        : details?.department?.id,

      email: details.email,
      centerId: details.centerId,
      // centerId: details.centerId ? details.centerId : details?.center?.id,
      name: details.name,
      platformIds: checkedItemsId.map((value) => Number(value)),
      qualificationIds: details.qualificationIds,
      registrationNumber: details.registrationNumber,
      specialisationIds: details.specialisationIds,
      startYear: details.startYear,
      isMykare: checkedItemsId?.includes(0),
      taskId: taskId,
      doctorType: doctorType,
      referenceLinks: details.referralLink,
    };

    if (id) {
      postData.professionalId = id;
    }

    if (!details.name) {
      setIsDoctorlFieldsValid({ ...isDoctorlFieldsValid, isName: true });
      return; // Return early and display an error message for the name field
    } else if (
      details.qualificationIds &&
      details.qualificationIds.length == 0
    ) {
      setIsDoctorlFieldsValid({ ...isDoctorlFieldsValid, qualification: true });
      return; // Return early and display an error message for the contact number field
    } else if (!details.startYear) {
      setIsDoctorlFieldsValid({ ...isDoctorlFieldsValid, experience: true });
      return;
    } else if (!postData.departmentId) {
      setIsDoctorlFieldsValid({ ...isDoctorlFieldsValid, department: true });
      return;
    } else if (!postData.centerId) {
      setIsDoctorlFieldsValid({ ...isDoctorlFieldsValid, center: true });
      return;
    } else {
      const response = await genericFetchData(
        `/professional/save`,
        "POST",
        postData
      );
      const status = response.status;
      const responseData = await response.json();
      if (status == 200) {
        if (doc.doctorDoc.length) {
          saveDoctorDocuments(
            doc.doctorDoc.map((val) => val),
            responseData.id,
            doctor_medical_council_document
          );
        }
        if (doc.doctorImage.length) {
          saveDoctorDocuments(doc.doctorImage, responseData.id, doctor_image);
        }
        if (doc.documentIds.length) {
          const deleteResponse = await genericFetchData(
            `/document/delete?documentIds=${doc.documentIds.map((id) => id)}`,
            "DELETE"
          );
          if (deleteResponse.status == 200) {
            console.log("error=================", deleteResponse.status);
          }
        }
        if (doc.agreementDoc.length) {
          saveDoctorDocuments(
            doc.agreementDoc.map((val) => val),
            responseData.id,
            doctor_agreement
          );
        }
        if (doc.documentIds.length) {
          const deleteResponse = await genericFetchData(
            `/document/delete?documentIds=${doc?.documentIds?.map((id) => id)}`,
            "DELETE"
          );
          if (deleteResponse == 200) {
            console.log("error=================", deleteResponse.status);
          }
        }
        alert("saved successfully");
        setIsPersonalEditable(false);
        getDocuments(responseData.id);
        getImages(responseData.id);
        getAgreementDoc(responseData.id);
        navigate("/doctors");
      } else {
        console.log("=======error", responseData);
      }
    }
  };

  const financeDetailSave = async () => {
    var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
    const doctorTreatments = details.doctorTreatmentShares.map((val) => {
      return {
        doctorShare: val.doctorShare,
        treatmentId: val?.treatment ? val?.treatment?.id : val?.treatmentId,
      };
    });
    const postData = {
      agreementExpiryFrom: details.doctorFinance.agreementExpiryFrom
        ? new Date(
          details.doctorFinance.agreementExpiryFrom.replace(
            pattern,
            "$3-$2-$1"
          )
        )
        : "",
      agreementExpiryTo: details.doctorFinance.agreementExpiryTo
        ? new Date(
          details.doctorFinance.agreementExpiryTo.replace(pattern, "$3-$2-$1")
        )
        : "",
      ipDoctorShare: details.doctorFinance.ipDoctorShare,
      opMinConsultationFee: details.doctorFinance.opMinConsultationFee,
      opMykareShare: details.doctorFinance.opMykareShare,
      doctorTreatmentShares: doctorTreatments,
    };

    if (id) {
      postData.doctorId = id;
    }

    const response = await genericFetchData(
      `/professional/finance/save`,
      "POST",
      postData
    );

    const status = response.status;
    const responseData = await response.json();

    if (status == 200) {
      alert("saved successfully");
      setIsFinanceEditable(false);
      getDoctorDetails(id);

      if (userRole === "FINANCE_MANAGER") {
        navigate("/mySpace");
      } else if (userRole === "FINANCE_EXECUTIVE") {
        navigate("/doctors");
      }
    } else {
      console.log("=======error", responseData);
    }
  };

  useEffect(() => {
    getAllQualification();
    getAllSpecialization();
    getAllDepartments();
    getAllhospitals();
    getAllTreatments();
    if (id) {
      getDoctorDetails(id);
      getAgreementDoc(id);
      getDocuments(id);
      getImages(id);
    }
  }, []);

  const [activeTab, setActiveTab] = useState(0);
  const [approveModal, setApproveModal] = useState(false);
  const [disApproveModal, setDisApproveModal] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const approve = () => {
    setApproveModal(!approveModal);
  };

  const handleControl = (status) => {
    if (status === "REJECTED") {
      if (!rejectedReason) {
        setError(true);
      } else {
        setDisApproveModal(false);
        setError(false);
      }
    } else if (status === "APPROVED") {
      setApproveModal(false);
    }
    handleDisapprove(status);
  };

  const disSpprove = () => {
    setDisApproveModal(!disApproveModal);
  };

  const tabContents = [
    checkPermission("DB_DOCTOR_DETAILS_EDIT") ? (
      <PersonalDetails
        isEditable={isPersonalEditable}
        setDoctorType={setDoctorType}
        doctorType={doctorType}
        setIsEditable={setIsPersonalEditable}
        setIsDoctorlFieldsValid={setIsDoctorlFieldsValid}
        isDoctorlFieldsValid={isDoctorlFieldsValid}
        doc={doc}
        setDoc={setDoc}
        setDetails={setDetails}
        details={details}
        departments={departments}
        hospitals={hospitals}
        qualification={qualification}
        specialization={specialization}
        checkedItems={checkedItems}
        items={items}
        setCheckedItems={setCheckedItems}
        setCheckedItemsId={setCheckedItemsId}
        duplicateName={duplicateName}
        id={id}
        onSave={() => {
          personalDetailSave();
        }}
        isLive={isLive}
        onDisapprove={disSpprove}
      />
    ) : (
      <PersonalDetailsView
        isEditable={false}
        setIsEditable={setIsPersonalEditable}
        doc={doc}
        setDoc={setDoc}
        setDetails={setDetails}
        details={details}
        departments={departments}
        hospitals={hospitals}
        qualification={qualification}
        specialization={specialization}
        checkedItems={checkedItems}
        items={items}
        setCheckedItems={setCheckedItems}
        setCheckedItemsId={setCheckedItemsId}
        id={id}
        onSave={() => {
          personalDetailSave();
        }}
      />
    ),
    <FinanceTab
      id={id}
      details={details}
      setDetails={setDetails}
      isFinanceEditable={isFinanceEditable}
      setIsFinanceEditable={setIsFinanceEditable}
      handleDuplicate={handleDuplicate}
      financeDetailSave={financeDetailSave}
      treatments={treatments}
    ></FinanceTab>,
  ];

  return (
    <Grid
      sx={{
        width: "77%",
        height: "95vh",
        padding: "0px 25px",
      }}
    >
      <Grid
        lg={12}
        container
        sx={{
          width: "100%",
          backgroundColor: "#f9fbfc",
          padding: "40px",
          // height: "10vh",
        }}
      >
        <Grid lg={12} item container>
          <Grid lg={2}>
            <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
              {id ? details?.name : "Add New Doctor"}
            </Typography>
          </Grid>
          <Grid lg={3}>
            <div className="App">
              <Tabs
                className={classes.tabs}
                value={activeTab}
                onChange={handleTabChange}
                variant="standard"
                indicatorColor="transparent"
                TabScrollButtonProps={{ style: { backgroundColor: "black" } }}
              >
                <Tab
                  className={
                    activeTab === 0 ? "active-tab-button" : "tab-button"
                  }
                  label="Medical"
                />
                {!isShow && (
                  <Tab
                    className={
                      activeTab === 1 ? "active-tab-button" : "tab-button"
                    }
                    label="Finance"
                  />
                )}
              </Tabs>
            </div>
          </Grid>
          {state?.status !== "Rejected" ? (
            <>
              {!isLive && (
                <Grid lg={6}>
                  <Box display={"flex"} gap={1} justifyContent={"flex-end"}>
                    {checkPermission("KARE_DB_APROVAL") && (
                      <Box
                        component={"button"}
                        width={"140px"}
                        height={"36px"}
                        border={"solid 1px #66718A"}
                        bgcolor={"#F9FBFC"}
                        color={"#4C5A6A"}
                        fontSize={"14px"}
                        borderRadius={"8px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        gap={1}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={approve}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Edit />
                        </Box>
                        <Typography>Approve</Typography>
                      </Box>
                    )}
                    {checkPermission("KARE_DB_APROVAL") && (
                      <Box
                        component={"button"}
                        width={"140px"}
                        height={"36px"}
                        border={"solid 1px #66718A"}
                        bgcolor={"#F9FBFC"}
                        color={"#4C5A6A"}
                        fontSize={"14px"}
                        borderRadius={"8px"}
                        display={"flex"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        gap={1}
                        sx={{
                          cursor: "pointer",
                        }}
                        onClick={disSpprove}
                      >
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Edit />
                        </Box>
                        <Typography>Disapprove</Typography>
                      </Box>
                    )}
                  </Box>
                </Grid>
              )}
            </>
          ) : (
            <Grid lg={6} container justifyContent={"flex-end"}>
              <Box
                component={"button"}
                width={"150px"}
                height={"36px"}
                border={"solid 1px #f66c61"}
                bgcolor={"#f66c61"}
                color={"white"}
                fontSize={"14px"}
                borderRadius={"8px"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                gap={1}
                sx={{
                  cursor: "pointer",
                }}
              >
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <DisApprove />
                </Box>
                <Typography>Disapproved</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
        <Divider />
      </Grid>

      <Grid
        sx={{
          width: "100%",
          padding: " 10px 40px",
          height: "80vh",
          backgroundColor: "#f9fbfc",
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            width: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "lightgray",
            visibility: "hidden",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "gray",
          },
        }}
      >
        <Journy dataType={"PROFESSIONAL"} tileId={id} />

        {presentTab && activeTab === 0 && locationData?.rejectedReason && (
          <Rejection
            locationData={locationData}
            setIsEditable={setIsEditable}
            setIsPersonalEditable={setIsPersonalEditable}
            isActivetab={"MEDICAL"}
          />
        )}

        <Box className="tab-content">{tabContents[activeTab]}</Box>
      </Grid>

      <DisApproveModal
        handleControl={handleControl}
        disApproveModal={disApproveModal}
        setDisApproveModal={setDisApproveModal}
        setRejectedReason={setRejectedReason}
        error={error}
        rejectedReason={rejectedReason}
      />
      <ApproveModa
        // handleControl={handleControl}
        handleControl={handleControl}
        setApproveModal={setApproveModal}
        approveModal={approveModal}
      />
    </Grid>
  );
}
